import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { FreeResourceSummaryBaseEffect } from './free-resource-summary-base.effect';

@NgModule({
  imports: [
    EffectsModule.forFeature([ FreeResourceSummaryBaseEffect ])
  ]
})
export class FreeResourceSummaryModule {

}
